
let vars, functions,
functionality={

  vars:{
  //-----------------------SLIDER variables-----------------------------

    videoSlider:document.getElementById("video-slider"), //slider bar option element
    videoSliderDiv:document.getElementById("videoSlider-div"), //slider bar container element
    sliderListenerAdded:false,
    currentFrameInput:document.getElementById('current-frame'),

  //---------------------ARROWS variables-------------------------

    arrowsDiv:document.getElementById("arrows-section"),//arrows container element
    leftArrow:document.getElementById("left-navigation"), //left arrow navigation
    rightArrow:document.getElementById("right-navigation"), //left arrow navigation
    arrowsListenerAdded:false,
    stopPointsArray:[], //array stores stop points entered by user.
    playingForward:false, //if the forward arrow was pressed
    playingBackward:false, //if the backward arrow was pressed
  
     //---------------------SCROLL variables-------------------------
     scrolled:false, //Bool check if the scroll event occured.
     scrollListenerAdded:false,
     scrollValueInput:document.getElementById('scrollValue'),
     scrollValue:1,

  //------------- CANVAS variables----------------------
    c2 : null, //canvas element
    ctx2 :null, //canvas contex
    width:0,  //width of canvas
    height:0,  //height of canvas

     //---------------------FRAMES DATA variables-------------------------
       
     frames:[], //The array containing the FRAMES DATA.
     framesCount:0, // The NUMBER of frames 
     currentFrame:0, //the frame currently on the canvas

     //-----------admin/user---------------
     user:'',
  },
  init:function(user){
    vars = this.vars
    functions = this.functions
    vars.user=user;

  
  },
  functions:{
    setStopArray:function(stopArray){
      vars.stopPointsArray=stopArray;
    },
    setCanvas:function(canvas,canvasContext,width,height){
      vars.c2=canvas
      vars.ctx2=canvasContext
      vars.width=width
      vars.height=height
     

    },
    setFrameData:function(framesArray,framesCount, currentFrame){
      vars.frames=framesArray
     
      vars.framesCount=framesCount
      vars.currentFrame=currentFrame

    },
    drawFrameOnCanvas:function(){
      
        if(vars.user==="client"){
            vars.ctx2.clearRect (0, 0, vars.width, vars.height);
            vars.ctx2.drawImage(vars.frames[vars.currentFrame],0, 0, vars.width, vars.height);
        }else if(vars.user==="admin"){
          
            vars.ctx2.putImageData(vars.frames[vars.currentFrame], 0, 0);
        }
       
    //   
  },
  addEventListeners:function(){
    // vars.videoSlider.addEventListener('input',functions.handleSliderInput)
    vars.leftArrow.addEventListener('click',  (e)=>functions.playForward(e))
    vars.rightArrow.addEventListener('click',  (e)=>functions.playBackward(e))
  },
  removeEventListeners:function(){
    // vars.videoSlider.removeEventListener('input',functions.handleSliderInput)
    vars.leftArrow.removeEventListener('click',  (e)=>functions.playForward(e))
    vars.rightArrow.removeEventListener('click',  (e)=>functions.playBackward(e))
  },
  handleWheelWithArrows:function(e){ //handler for scoll/wheel event
    
    if(!vars.scrolled){
        if(e.deltaY>0){
            //mouse scrolled down
            functions.playBackward();
           
        }
        if(e.deltaY<0){
            //mouse scrolled up
            functions.playForward();
        }
       
    }

},

  

    // Slider
    addSlider:function(){
        functions.drawFrameOnCanvas()
      //show slider option hide other options
    
      
    
      vars.videoSlider.max= vars.frames.length-1+"";
      vars.videoSlider.min=-vars.frames.length+1+"";
      


      vars.videoSlider.value="0";
      if(vars.user==="admin"){
        vars.currentFrameInput.value=parseInt(vars.videoSlider.value)
    }
     
      
      vars.videoSliderDiv.classList.remove('d-none')
      vars.arrowsDiv.classList.add("d-none")
      if(vars.scrollListenerAdded===true){
          vars.c2.removeEventListener('wheel',functions.handleWheel)// remove event listener for scroll
          vars.scrollListenerAdded=false;
       }
      
      //define event listener for slider if not defined
      if(vars.sliderListenerAdded===false){
          vars.c2.addEventListener('wheel',functions.handleWheelWithSlider)
          vars.videoSlider.addEventListener('input',functions.handleSliderInput)
          vars.sliderListenerAdded=true // if true the listener have been already added
      }
  },
  handleWheelWithSlider:function(e){ //handler for scoll/wheel event
   
    let sliderValue = parseInt(vars.videoSlider.value);

    if(!vars.scrolled){
        if(e.deltaY>0){
            //mouse scrolled down
            sliderValue++;
            vars.videoSlider.value=sliderValue+``
            functions.handleSliderInput()
           
        }
        if(e.deltaY<0){
            //mouse scrolled up
          
            sliderValue--;
            vars.videoSlider.value=sliderValue+``
            functions.handleSliderInput()
        }
        if(vars.user==="admin"){
            vars.currentFrameInput.value=parseInt(vars.videoSlider.value)
        }
        
       
    }

},
  handleSliderInput:function(e){  //handler for scroll event
    let sliderValue = parseInt(vars.videoSlider.value);
   
       
    if(sliderValue<0){
        sliderValue=vars.frames.length-1+sliderValue;
      
    }
    if(vars.user==="admin"){
        vars.currentFrameInput.value=sliderValue
    }
  
  
    vars.currentFrame=sliderValue; //set the current frame to slider input value
     functions.drawFrameOnCanvas();
},

//--------------------------------------------------------------------------------------


//
//
//
//


//--------------------------------------ARROWS Functionality---------------------------------------------

addArrows:function(){
    
  //  functions.addArrowsStopPoints(); // additional event listeners
   
    vars.arrowsDiv.classList.remove("d-none") // show component
    vars.videoSliderDiv.classList.add('d-none')// remove slider ; d-none -> display-none
    functions.drawFrameOnCanvas()
    
   

    //define event listeners for arrows if not defined
    if(vars.arrowsListenerAdded===false){
     
     vars.c2.addEventListener('wheel',functions.handleWheelWithArrows)
        vars.leftArrow.addEventListener('click',  (e)=>functions.playForward(e))
        vars.rightArrow.addEventListener('click',  (e)=>functions.playBackward(e))
        vars.arrowsListenerAdded=true // if true the listeners have been already added
    }
},
   //implement arrow functionality
   findNextStopPoint:function(){
         
    if(vars.playForward){
        if(vars.stopPointsArray.length===0){ //if no stop points have been added play full cicle
            return vars.framesCount
        }
        for(let i=0;i<vars.stopPointsArray.length;i++){
            if(vars.stopPointsArray[i]===-1){
                //do nothing; skip this entry - invalid entry is marked with -1 and deleted when final settings are saved.
            }else
            if(vars.currentFrame<vars.stopPointsArray[i])
            {
               
                return vars.stopPointsArray[i]
            }
        }
       
            return vars.frames.length-1
        
    }
    if(vars.playBackward){
       
        if(vars.stopPointsArray.length===0){ //if no stop points have been added play full cicle
            return 0
        }

        let backwardStartFrame=vars.currentFrame

        if(backwardStartFrame<=0){
            backwardStartFrame=vars.frames.length-1;
           
        }
       
        for(let i=vars.stopPointsArray.length-1;i>=0;i--){
            if(vars.stopPointsArray[i]===-1){
                //do nothing; skip this entry - invalid entry is marked with -1 and deleted when final settings are saved.
            }else
            if(backwardStartFrame>vars.stopPointsArray[i])
            {
               return vars.stopPointsArray[i]
            }
        }
        
        return 0
    }

},
playForward:function(e){
      //remove the event listeners to prevent other event occuring while the interval is playing
      functions.removeEventListeners()
    //   e.stopPropagation();
     
    if(vars.playBackward===true ){  //if the backward interval is playing don't execute
        return
    }
    if(vars.playForward===true ){ //if the forward interval is still executing from previous event don't execute the rest of the function
        return
    }
   
   
    let forwardInterval=null;
    clearInterval(forwardInterval)
    
    vars.playForward=true;
    let startFrame=vars.currentFrame;
    let endFrame=functions.findNextStopPoint()

  
    forwardInterval= setInterval(function(){ 
       
            if(startFrame<endFrame  ){
                
                if(startFrame<vars.frames.length ){
                    vars.currentFrame=startFrame;
                    functions.drawFrameOnCanvas(); //put the frame at currentFrame variable index on canvas
                    startFrame++;   
                    
                } 
            }else{
                vars.currentFrame=endFrame;
               
                
                if(endFrame>=vars.frames.length-1){
                    vars.currentFrame=0;
                }
               
                functions.drawFrameOnCanvas(); //put the frame at currentFrame variable index on canvas
                functions.addEventListeners()  //add back event listeners to be ready for next action
                vars.playForward=false;
                clearInterval(forwardInterval)
            }


        
             
         
          
        },1000/25)


},
playBackward:function(e){
    
      //remove the event listeners to prevent other event occuring while the interval is playing
      functions.removeEventListeners()
    //   e.stopPropagation();
    if(vars.playBackward===true ){
        return
    }
    if(vars.playForward===true ){
        return
    }
  
 
   vars.playBackward=true;
    let backwardInterval=null;
    clearInterval(backwardInterval)
    

   if(vars.currentFrame===0){
       vars.currentFrame=vars.frames.length-1;
     
   }
    let endFrame=functions.findNextStopPoint()
    let startFrame=vars.currentFrame;
  

   
 
    backwardInterval= setInterval(function(){
      
            if(startFrame>endFrame ){
                if(startFrame===0){
                    startFrame=vars.frames.lenght-1;
                }
                if(startFrame>0 ){
                   vars.currentFrame=startFrame;
                    functions.drawFrameOnCanvas()
                    startFrame--;
                }
             
               
            }else{
               
                vars.currentFrame=endFrame;
                vars.playBackward=false;
                functions.drawFrameOnCanvas()
               
                if(endFrame<=0){
                  
                    vars.currentFrame=0;
                   
                }
                functions.addEventListeners()  //add back event listeners to be ready for next action

                clearInterval(backwardInterval)
            }

        
          
                

         
          
        },1000/25)


},
  }
      

        

}

export default functionality;